import React from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

import TextArea from 'components/shared/debouncedTextArea';

const SelectOption = ({
  content,
  applyChanges,
  handleUpdate,
  questionType,
}) => {
  let placeholder = '';
  let hint = '';
  switch (questionType) {
    case 'multiple_choice':
      placeholder = t(
        'questions.question.select_option.multiple_choice_placeholder',
      );
      hint = t('questions.question.select_option.multiple_choice_hint');
      break;
    case 'multiple_select':
      placeholder = t(
        'questions.question.select_option.multiple_select_placeholder',
      );
      hint = t('questions.question.select_option.multiple_select_hint');
      break;
    case 'survey':
      placeholder = t('questions.question.select_option.survey_placeholder');
      hint = t('questions.question.select_option.survey_hint');
      break;
    default:
  }

  return (
    <div className="pt-24 pl-32 pr-32 pb-32 border-solid border-1 border-gray-light border-top-0 bdrs-small-bottom">
      <div className="d-f fd-c">
        <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD} className="pb-4">
          {' '}
          {t('questions.question.select_option.prompt')}
        </Text>
        <Text variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD} className="pb-14">
          {' '}
          {hint}
        </Text>
      </div>
      <TextArea
        className="EditorElement-input EditorElement-input--multiline bdrs-small "
        placeholder={placeholder}
        value={content.raw_choices}
        onChange={choices => {
          applyChanges({ raw_choices: choices });
          handleUpdate({ raw_choices: choices });
        }}
      />
    </div>
  );
};

export default SelectOption;
